<template>
  <div class="contents9">
    <img class="bg" :src="bgImg" />
    <div class="contents">
      <p class="text1">언론에서 만나는 카랑</p>
      <div class="news" v-if="!isMobile">
        <div class="card">
          <img :src="newsImg + '11.png'" @click="getNews(11)" />
        </div>
        <div class="card">
          <img :src="newsImg + '10.png'" @click="getNews(10)" />
        </div>
        <div class="card">
          <img :src="newsImg + '9.png'" @click="getNews(9)" />
        </div>
        <div class="card">
          <img :src="newsImg + '8.png'" @click="getNews(8)" />
        </div>
        <div class="card">
          <img :src="newsImg + '7.png'" @click="getNews(7)" />
        </div>
        <div class="card">
          <img :src="newsImg + '6.png'" @click="getNews(6)" />
        </div>
        <div class="card">
          <img :src="newsImg + '5.png'" @click="getNews(5)" />
        </div>
        <div class="card">
          <img :src="newsImg + '4.png'" @click="getNews(4)" />
        </div>
        <div class="card">
          <img :src="newsImg + '3.png'" @click="getNews(3)" />
        </div>
        <div class="card">
          <img :src="newsImg + '2.png'" @click="getNews(2)" />
        </div>
        <div class="card">
          <img :src="newsImg + '1.png'" @click="getNews(1)" />
        </div>
      </div>
      <div class="news" v-else>
        <div class="card">
          <img :src="newsImg + '11.png'" @click="getNews(11)" />
          <img :src="newsImg + '10.png'" @click="getNews(10)" />
          <img :src="newsImg + '8.png'" @click="getNews(8)" />
          <img :src="newsImg + '6.png'" @click="getNews(6)" />
          <img :src="newsImg + '4.png'" @click="getNews(4)" />
          <img :src="newsImg + '2.png'" @click="getNews(2)" />
        </div>
        <div class="card">
          <img :src="newsImg + '9.png'" @click="getNews(9)" />
          <img :src="newsImg + '7.png'" @click="getNews(7)" />
          <img :src="newsImg + '5.png'" @click="getNews(5)" />
          <img :src="newsImg + '3.png'" @click="getNews(3)" />
          <img :src="newsImg + '1.png'" @click="getNews(1)" />
        </div>
      </div>
      <div class="btn">
        <a @click="gotoPage()"><img :src="newsBtn"/></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: 'static/img/main-content/contents9.png',
      newsImg: 'static/img/news',
      newsBtn: 'static/img/newsBtn.png',
      isMobile: false
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.bgImg = 'static/img/main-content/contents9.png'
        this.newsImg = 'static/img/news'
        this.newsBtn = 'static/img/newsBtn.png'
        this.isMobile = false
      } else {
        this.bgImg = 'static/img/mobile/main-content/contents9.png'
        this.newsImg = 'static/img/mobile/main-content/news'
        this.newsBtn = 'static/img/mobile/main-content/newsBtn.png'
        this.isMobile = true
      }
    },
    getNews(index) {
      if (index === 1) {
        window.open('https://www.news1.kr/articles/?4675037')
      } else if (index === 2) {
        window.open('https://www.venturesquare.net/842351')
      } else if (index === 3) {
        window.open('https://news.v.daum.net/v/20210603142912751')
      } else if (index === 4) {
        window.open('https://news.v.daum.net/v/20210415144442741')
      } else if (index === 5) {
        window.open('http://www.bizhankook.com/bk/article/21700')
      } else if (index === 6) {
        window.open('http://www.kbiznews.co.kr/news/articleView.html?idxno=79583')
      } else if (index === 7) {
        window.open('http://www.koit.co.kr/news/articleView.html?idxno=110665')
      } else if (index === 8) {
        window.open('https://www.venturesquare.net/870953')
      } else if (index === 9) {
        window.open('http://news.heraldcorp.com/view.php?ud=20230726000624')
      } else if (index === 10) {
        window.open('https://www.venturesquare.net/895837')
      } else if (index === 11) {
        window.open('https://platum.kr/archives/221321')
      } else {
        this.gotoPage()
      }
    },
    gotoPage() {
      window.open(
        'https://search.naver.com/search.naver?sm=tab_hty.top&where=news&query=%EC%B9%B4%EC%88%98%EB%A6%AC&oquery=%EB%AF%B8%EC%8A%A4%ED%84%B0%ED%94%BD&tqi=hvOLidp0Jy0ssUQy67lssssssKd-376110'
      )
    }
  }
}
</script>

<style scoped>
.contents9 {
  width: 100%;
  position: relative;
}
.contents9 .bg {
  width: 100%;
  height: auto;
  display: block;
}

/* pc */
@media (max-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 37px;
    line-height: 40px;
    color: #000000;
    margin-bottom: 2%;
  }
  .btn img {
    width: 190px;
    height: auto;
    cursor: pointer;
  }
}
@media (min-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 2.9vw;
    line-height: 3.6vw;
    color: #000000;
    margin-bottom: 2%;
  }
  .btn img {
    width: 15vw;
    height: auto;
    cursor: pointer;
  }
}
@media (min-width: 641px) {
  .contents9 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 5% 15% 0 15%;
    text-align: center;
  }
  .news {
    width: 100%;
    max-width: 100%;
    height: 60%;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 4%;
    margin-bottom: 3%;
  }
  .news .card {
    width: 25%;
    border-radius: 10px;
    display: inline-block;
    vertical-align: top;
  }
  .news .card img {
    width: 100%;
    height: auto;
    cursor: pointer;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents9 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    text-align: center;
  }
  .text1 {
    margin-top: 20%;
    font-style: normal;
    font-weight: 300;
    font-size: 6.4vw;
    line-height: 10vw;
    color: #000000;
    margin-bottom: 20%;
  }
  .news {
    width: 100%;
    max-width: 100%;
    height: 65%;
    margin-top: 5%;
    margin-bottom: 24%;
  }
  .news .card {
    width: 49%;
    border-radius: 10px;
    display: inline-block;
    vertical-align: top;
  }
  .news .card img {
    width: 100%;
    height: auto;
    cursor: pointer;
  }
  .btn img {
    width: 60vw;
    height: auto;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/Contents9.vue